import React from 'react'
import clsx from 'clsx'

/**
 * @typedef {Object} Props
 * @property {boolean} Props.disabled
 * @property {boolean} Props.defaultChecked - intial value
 * @property {boolean | 'partial'} Props.checked
 * @property {(checked: boolean) => void} Props.onChange
 * @property {string} Props.text - label
 * @property {string} Props.id - optional needed for uncontrolled input
 */

/**
 * @param {Props} props 
 * @param {React.ForwardedRef<HTMLInputElement>} ref
 */
function Checkbox(props, ref) {
    const {
        onChange,
        checked,
        defaultChecked,
        disabled,
        text,
        id,
        ...rest
    } = props

    const input = <input
        type="checkbox"
        checked={checked}
        defaultChecked={defaultChecked}
        disabled={disabled}
        id={id}
        onClick={(e)=>{
            e.stopPropagation()
        }}
        onChange={e => {
            if (onChange && !disabled) {
                onChange(e.target.checked)
            }
        }}
        ref={ref}
    />

    const icon = <i
        className={clsx('ui-icon ui-icon_color-light', {
            'ui-icon-minus': (checked ?? defaultChecked) === 'partial',
            'ui-icon-check': typeof checked === 'boolean' || typeof defaultChecked === 'boolean',
        })}
        //title={checked ? 'Poista valinta' : 'Valitse'}// is this really needed? checkbox is self explanatory
    />

    return <label
            className={clsx('label-set', {
                'label-set-disabled': disabled,
                'has-text': text !== '' && text,
            })}
            {...rest}
            onClick={(e)=>{
                e.stopPropagation()
            }}
            data-tooltip={props.tooltip}
        >
        {input}
        {icon}
        {text !== '' && text ? <span>{text}</span> : null}
    </label>
}

export default React.forwardRef(Checkbox)